import React, { forwardRef } from 'react';

import { useIntl } from 'react-intl';

import { LOYALTY_REWARDS_POINTS_TEXT_ID } from './constants';
import {
  Container,
  Content,
  PointsNumber,
  PointsText,
  StyledPointsIcon,
  StyledRewardsLogo,
  Wrapper,
} from './loyalty-rewards-balance.styled';
import { ILoyaltyRewardsBalanceViewProps } from './types';

export const LoyaltyRewardsBalanceView = forwardRef<
  HTMLDivElement,
  ILoyaltyRewardsBalanceViewProps
>(({ availablePoints, appliedPoints }, ref) => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper ref={ref}>
      <Container>
        <Content>
          <StyledRewardsLogo data-testid="rewards-logo" inverted />
          <StyledPointsIcon data-testid="points-icon" />
          <PointsNumber data-testid="points">{availablePoints}</PointsNumber>
        </Content>
        <Content>
          <PointsText data-testid="points-applied-text">
            {formatMessage({ id: LOYALTY_REWARDS_POINTS_TEXT_ID })}
          </PointsText>
          <PointsNumber data-testid="points-applied">{appliedPoints}</PointsNumber>
        </Content>
      </Container>
    </Wrapper>
  );
});
